import gql from 'graphql-tag';

export const QUERY = gql([
    `
query FindEnseigneContent($filter: String!) {
  brands : queryCornerMarqueContents(top: 100, skip: 0, filter: $filter, search: null, orderby: "data/pageTitle/iv") {
    id
    data {
      pageTitle {
        iv
      }
      seoDescription {
        iv
      }
      seoKeywords {
        iv
      }
      seoThumbnail {
        iv {
          url
        }
      }
      thumbTitle {
        iv
      }
      thumbSubTitle {
        iv
      }
      thumbImage {
        iv {
          url
          fileSize
        }
      }
      universe {
        iv {
          id
        }
      }
      brandId {
        iv
      }
    }
  }
  universes : queryUniversListeContents(top: 100, skip: 0, filter: null, search: null, orderby: "data/value/iv") {
    id,
    data {
      text {
        iv
      }
    }
  }
  content : queryEnseigneContents(top: 1, skip: 0, filter: $filter) {
    data {
      pageTitle {
        iv
      }
      titleBlocTitle {
        iv
      }
      titleBlocSubTitle {
        iv
      }
      titleBlocFontSizeTitle {
        iv
      }
      titleBlocFontSizeSubTitle {
        iv
      }
      titleBlocWidth {
        iv
      }
      titleBlocTagline {
        iv
      }
      titleBlocTextColor {
        iv
      }
      titleBlocColor {
        iv
      }
      titleBlocCtaLink {
        iv
      }
      titleBlocCtaText {
        iv
      }
      titleBlocCtaLink2 {
        iv
      }
      titleBlocCtaText2 {
        iv
      }
      titleBlocCtaStyle2 {
        iv
      }
      titleBlocPicture {
        iv {
          url
          fileSize
        }
      }
      titleBlocHorizontalPosition {
        iv
      }
      titleBlocJustification {
        iv
      }
      ribbonTitle {
        iv
      }
      ribbonColor {
        iv
      }
      ribbonPicture {
        iv {
          url
          fileSize
        }
      }
      ribbonList {
        iv {
          title
          subTitle
          picture {
            url
            fileSize
          }
          color
        }
      }
      title {
        iv
      }
      titleFontSize {
        iv
      }
      titleTextColor {
        iv
      }
      description {
        iv
      }
      descriptionFontSize {
        iv
      }
      descriptionTextColor {
        iv
      }

      mention {
        iv
      }
      mentionFontSize {
        iv
      }
      mentionTextColor {
        iv
      }

      preFooterPictureList {
        iv {
          picture {
            url
            fileSize
          }
          pictureLink
          text
        }
      }
      preFooterColor {
        iv
      }
    }
  }
}
`,
]);
